<script setup lang="ts">

import { TransactionListActionTypes, useTransactionStore } from '@/modules/transaction/stores/transaction.list.store.ts'
import DepositPanel from '@/modules/transaction/views/DepositPanel.vue'
import WithdrawPanel from '@/modules/transaction/views/WithdrawPanel.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import Modal from '@/onenetwork/components/modal/Modal.vue'
import _ from 'lodash'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import WithdrawProcess from './WithdrawProcess.vue'

interface Props {
  account?: object | undefined
  defautAction?: string | undefined
}

const props = defineProps<Props>()

const displayDepositPanel = ref(props.defautAction === 'deposit' || false)
const displayWithdrawPanel = ref(false)
const displayWithdrawProcessPanel = ref(false)
const selectedWithdrawItem = ref<any>({})

const router = useRouter()

const transactionListStore = useTransactionStore()

watch(() => props.defautAction, (newVal) => {
  transactionListStore.resetFilter()
  if (newVal === 'deposit') {
    transactionListStore.putFilter('type', 'deposit')
  } else if (newVal === 'withdraw') {
    transactionListStore.putFilter('type', 'withdrawal')
  }
}, { immediate: true })


const TableConfig = computed(() => {
  return transactionListStore.tableConfig
})
const filter = computed(() => {
  return transactionListStore.filter
})
const loading = computed(() => {
  return transactionListStore.action_type == TransactionListActionTypes.FETCHING
})
const page = computed(() => {
  return transactionListStore.page
})
const pageSize = computed(() => {
  return transactionListStore.pageSize
})
const dataSource = computed(() => {
  return transactionListStore.data
})

const handleChangePage = (page: number) => {

  transactionListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  transactionListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  transactionListStore.setFilter(filter)
}

const handleSort = (field: string, direction: string) => {

  transactionListStore.toggleSort(field, direction)
}

const requestFetchTransactionList = _.debounce(async () => {
  try{
    const res = await transactionListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> transactionListStore.uuid, (newVal, oldVal) => {
  requestFetchTransactionList()
})

onMounted(() => {
  transactionListStore.resetFilter()

  if (props.account?.id) {
    transactionListStore.putFilter('account_id', props.account.id)
  }

  if (props.defautAction === 'deposit') {
    transactionListStore.putFilter('type', 'deposit')
  } else if (props.defautAction === 'withdraw') {
    transactionListStore.putFilter('type', 'withdrawal')
  }

})

const handleResetFilter = () => {

  transactionListStore.resetFilter()
}

</script>

<template>
    <filter-list
      :filter="filter"
      @update:filter="handleUpdateFilter"
      v-if="!props.account"
      @reset:filter="handleResetFilter"
    />
    <data-table
      :buttons="[
        {
          label: 'Nạp tiền thủ công',
          icon: 'tabler:moneybag-plus',
          class: 'btn bg-primary bg-hover-primary text-white',
          action: () => { displayDepositPanel = true },
          perm: 'transaction.deposit',
          selectRequired: false
        },
        {
          label: 'Trừ tiền thủ công',
          icon: 'tabler:moneybag-minus',
          class: 'btn btn-danger bg-hover-secondary',
          action: () => { displayWithdrawPanel = true },
          perm: 'transaction.withdraw',
          selectRequired: false
        },
      ]"
      :custom-action-cell="false"
      :loading="loading"
      :tableConfig="TableConfig"
      :page-size="pageSize"
      :page="page"
      :total-page="dataSource?.totalPage || 0"
      :total-records="dataSource?.totalRecords || 0"
      :data="dataSource?.list || []"
      @page-changed="handleChangePage"
      @pagesize-changed="handleChangePageSize"
      @on-sort="handleSort"
    />
  <Modal :show="displayDepositPanel" title="Nạp tiền vào tài khoản" @on:close="()=>{displayDepositPanel = false}">
    <DepositPanel :account="props.account" @update:closeModal="() => {
      displayDepositPanel = false
      //fetch list
      requestFetchTransactionList()
    }"/>
  </Modal>
  <Modal :show="displayWithdrawPanel" title="Rút tiền từ tài khoản" @on:close="()=>{displayWithdrawPanel = false}">
    <WithdrawPanel :account="props.account" @update:closeModal="() => {
      displayWithdrawPanel = false
      //fetch list
      requestFetchTransactionList()
    }"/>
  </Modal>
  <Modal :show="displayWithdrawProcessPanel" title="Xử lí rút tiền" @on:close="()=>{displayWithdrawProcessPanel = false}">
    <WithdrawProcess :account="selectedWithdrawItem" @update:closeModal="() => {
      displayWithdrawProcessPanel = false
      //fetch list
      requestFetchTransactionList()
    }" />
  </Modal>
</template>

<style scoped>

</style>
